export function getLocalStorage(): Storage | null {
  try {
    if (typeof localStorage === 'undefined') return null
    return localStorage
  } catch {
    return null
  }
}

export function readStorageText(key: string): string | null {
  const storage = getLocalStorage()
  if (!storage) return null
  try {
    return storage.getItem(key)
  } catch {
    return null
  }
}

export function writeStorageText(key: string, value: string): void {
  const storage = getLocalStorage()
  if (!storage) return
  try {
    storage.setItem(key, value)
  } catch {
    // ignore storage failures
  }
}

export function removeStorageText(key: string): void {
  const storage = getLocalStorage()
  if (!storage) return
  try {
    storage.removeItem(key)
  } catch {
    // ignore storage failures
  }
}

export function listStorageKeys(): string[] {
  const storage = getLocalStorage()
  if (!storage) return []

  try {
    const keys: string[] = []
    for (let i = 0; i < storage.length; i++) {
      const key = storage.key(i)
      if (key) keys.push(key)
    }
    return keys
  } catch {
    return []
  }
}

export function readStorageJson<T>(key: string, fallback: T): T {
  const raw = readStorageText(key)
  if (!raw) return fallback
  try {
    return JSON.parse(raw) as T
  } catch {
    return fallback
  }
}

export function writeStorageJson(key: string, value: unknown): void {
  try {
    writeStorageText(key, JSON.stringify(value))
  } catch {
    // ignore serialization failures
  }
}

export type JsonStorageRepo<T> = {
  read: () => T
  write: (value: T) => void
}

export function createJsonStorageRepo<T>(
  key: string,
  fallback: T,
  validate?: (value: unknown) => value is T,
): JsonStorageRepo<T> {
  return {
    read: () => {
      const parsed = readStorageJson<unknown>(key, fallback)
      if (validate && !validate(parsed)) return fallback
      return parsed as T
    },
    write: (value: T) => {
      writeStorageJson(key, value)
    },
  }
}
